// test1982
(1982 && 0);
